<template>
  <div class="EnterpriseCulture">
    <!-- 企业文化 -->
    <div class="EnterpriseCulture_box">
      <ul class="boxTop">
        <li>
          <div class="li1_box">
            <div class="li1_boxImg">
              <img src="@/assets/img/aboutUs/qywh_yj.png" alt="" />
            </div>
            <div class="li1_boxTitle">公司愿景</div>
            <div class="li1_boxText">
              成为全球领先的农林生态智能防控哨兵，让虫害预警更早一步，让生态管理更智一度
            </div>
          </div>
        </li>
        <li>
          <div class="li1_box">
            <div class="li1_boxImg">
              <img src="@/assets/img/aboutUs/qywh_sm.png" alt="" />
            </div>
            <div class="li1_boxTitle">公司使命</div>
            <div class="li1_boxText">
              用智能感知，守护绿色未来
            </div>
          </div>
        </li>
        <li>
          <div class="li3_box">
            <div class="li3_boxImg">
              <img src="@/assets/img/aboutUs/qywh_jzg.png" alt="" />
            </div>
            <div class="li3_boxTitle">公司价值观</div>
            <div class="li3_boxText">
              以持续的技术突破为根基，以守护农林安全、生态平衡为初心。
            </div>
          </div>
        </li>
      </ul>
      <div class="boxCenter">
        <ul class="centerBox">
          <li class="about">STYLE</li>
          <li>员工风采</li>
          <li>STAFF STYLE</li>
        </ul>
      </div>
      <div class="boxBottom">
        <div class="boxBottom_left">
          <el-carousel class="enterpriseCulture_Carousel" :autoplay="false">
            <el-carousel-item
              v-for="(item, index) in carouselArr"
              :key="item.id"
            >
              <!-- style="width: 19.2rem; height: 6.42rem" -->
              <el-image :src="item.url" class="custom-image"></el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
        <ul class="boxBottom_right">
          <li>
            <img src="@/assets/img/aboutUs/bgs2.jpg" alt="" />
            <div class="li1_right">
              办公区
              <div class="li1_right_x"></div>
              <div class="li1_right_jt">
                <img src="@/assets/img/aboutUs/gywm_xl.png" alt="" />
              </div>
              <div class="li1_right_sz">01</div>
            </div>
          </li>
          <li>
            <div class="li1_right">
              会客区
              <div class="li1_right_x"></div>
              <div class="li1_right_jt">
                <img src="@/assets/img/aboutUs/gywm_xl.png" alt="" />
              </div>
              <div class="li1_right_sz">02</div>
            </div>
            <img src="@/assets/img/aboutUs/bgs3.jpg" alt="" />
          </li>
          <li>
            <img src="@/assets/img/aboutUs/bgs4.jpg" alt="" />
            <div class="li1_right">
              校企合作
              <div class="li1_right_x"></div>
              <div class="li1_right_jt">
                <img src="@/assets/img/aboutUs/gywm_xl.png" alt="" />
              </div>
              <div class="li1_right_sz">03</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EnterpriseCulture",
  data() {
    return {
      carouselArr: [
        {
          id: "1",
          url: require("@/assets/img/aboutUs/bgs1.jpg")
        },
        {
          id: "2",
          url: require("@/assets/img/aboutUs/bgs1.jpg")
        },
        {
          id: "3",
          url: require("@/assets/img/aboutUs/bgs1.jpg")
        }
      ]
    };
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.EnterpriseCulture {
  width: 100%;
  background: url("../../../assets/img/aboutUs/qywh_bj4.png") no-repeat;
  background-size: 100% 1152px;
  .EnterpriseCulture_box {
    width: 100%;
    height: 1152px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 90px 350px 0;
    .boxTop {
      width: 100%;
      height: 246px;
      display: flex;
      justify-content: space-between;
      margin-top: 40px;
      li {
        width: 391px;
        height: 246px;
        &:nth-child(1) {
          background: url("../../../assets/img/aboutUs/qywh_bj1.png") no-repeat;
          background-size: 391px 246px;
          display: flex;
          justify-content: center;
          padding-top: 40px;
          .li1_box {
            width: 342px;
            height: 172px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .li1_boxImg {
              width: 100%;
              height: 56px;
              padding-left: 150px;
              img {
                width: 54px;
                height: 56px;
              }
            }
            .li1_boxTitle {
              width: 100%;
              height: 32px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              font-size: 35px;
              color: #ffffff;
              text-align: center;
            }
            .li1_boxText {
              width: 100%;
              height: 50px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              font-size: 16px;
              color: #ffffff;
              line-height: 26px;
              text-align: center;
            }
          }
        }
        &:nth-child(2) {
          background: url("../../../assets/img/aboutUs/qywh_bj2.png") no-repeat;
          background-size: 391px 246px;
          display: flex;
          justify-content: center;
          padding-top: 46px;
          .li1_box {
            width: 342px;
            height: 172px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .li1_boxImg {
              width: 100%;
              height: 48px;
              padding-left: 150px;
              img {
                width: 50px;
                height: 48px;
              }
            }
            .li1_boxTitle {
              width: 100%;
              height: 32px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              font-size: 35px;
              color: #ffffff;
              text-align: center;
            }
            .li1_boxText {
              width: 100%;
              height: 50px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              font-size: 16px;
              color: #ffffff;
              line-height: 26px;
              text-align: center;
            }
          }
        }
        &:nth-child(3) {
          background: url("../../../assets/img/aboutUs/qywh_bj3.png") no-repeat;
          background-size: 391px 246px;
          display: flex;
          justify-content: center;
          padding-top: 46px;
          .li3_box {
            width: 342px;
            height: 164px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .li3_boxImg {
              width: 100%;
              height: 48px;
              padding-left: 150px;
              img {
                width: 52px;
                height: 48px;
              }
            }
            .li3_boxTitle {
              width: 100%;
              height: 32px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              font-size: 35px;
              color: #ffffff;
              text-align: center;
            }
            .li3_boxText {
              width: 100%;
              height: 50px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              font-size: 16px;
              color: #ffffff;
              line-height: 26px;
              text-align: center;
            }
          }
        }
      }
    }
    .boxCenter {
      width: 100%;
      height: 144px;
      margin-top: 30px;
      .centerBox {
        width: 248px;
        height: 144px;
        margin: 0 auto;
        position: relative;
        li {
          &:nth-child(1) {
            width: 100%;
            height: 90px;
            color: #e1dede;
            font-size: 108px;
            position: relative;
            font-family: Impact;
            opacity: 0.7;
            &:after {
              content: "";
              width: 54px;
              height: 4px;
              background-color: #b3b1b1;
              position: absolute;
              left: -20px;
              top: 46px;
            }
          }
          &:nth-child(2) {
            width: 144px;
            height: 48px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            font-size: 36px;
            color: #333333;
            position: absolute;
            top: 76px;
            left: 50%;
            margin-left: -72px;
          }
          &:nth-child(3) {
            height: 20px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            font-size: 16px;
            color: #a3a3a3;
            position: absolute;
            top: 124px;
            left: 50%;
            margin-left: -50px;
          }
        }
      }
    }
    .boxBottom {
      width: 100%;
      height: 510px;
      display: flex;
      .boxBottom_left {
        width: 716px;
        height: 510px;
        .el-image {
          width: 716px !important;
          height: 510px !important;
        }
      }
      .boxBottom_right {
        flex: 1;
        li {
          &:nth-child(1) {
            width: 100%;
            height: 170px;
            display: flex;
            img {
              width: 280px;
              height: 170px;
            }
            .li1_right {
              flex: 1;
              line-height: 170px;
              background-color: #1c7e28;
              padding-left: 60px;
              position: relative;
              font-family: Microsoft YaHei;
              font-weight: bold;
              font-size: 20px;
              color: #ffffff;
              .li1_right_x {
                width: 1px;
                height: 24px;
                background-color: #fff;
                position: absolute;
                top: 74px;
                left: 138px;
              }
              .li1_right_jt {
                width: 24px;
                height: 13px;
                position: absolute;
                top: 0px;
                left: 150px;
                img {
                  width: 24px;
                  height: 13px;
                }
              }
              .li1_right_sz {
                width: 78px;
                height: 78px;
                font-size: 78px;
                color: #333333;
                font-weight: bold;
                font-family: Bahnschrift;
                opacity: 0.2;
                position: absolute;
                top: -28px;
                left: 120px;
              }
            }
          }
          &:nth-child(2) {
            width: 100%;
            height: 170px;
            display: flex;
            img {
              width: 280px;
              height: 170px;
            }
            .li1_right {
              flex: 1;
              line-height: 170px;
              background-color: #1c7e28;
              padding-left: 60px;
              position: relative;
              font-family: Microsoft YaHei;
              font-weight: bold;
              font-size: 20px;
              color: #ffffff;
              .li1_right_x {
                width: 1px;
                height: 24px;
                background-color: #fff;
                position: absolute;
                top: 74px;
                left: 138px;
              }
              .li1_right_jt {
                width: 24px;
                height: 13px;
                position: absolute;
                top: 0px;
                left: 150px;
                img {
                  width: 24px;
                  height: 13px;
                }
              }
              .li1_right_sz {
                width: 78px;
                height: 78px;
                font-size: 78px;
                color: #333333;
                font-family: Bahnschrift;
                font-weight: normal;
                opacity: 0.2;
                position: absolute;
                top: -26px;
                left: 12px;
              }
            }
          }
          &:nth-child(3) {
            width: 100%;
            height: 170px;
            display: flex;
            img {
              width: 280px;
              height: 170px;
            }
            .li1_right {
              flex: 1;
              line-height: 170px;
              background-color: #1c7e28;
              padding-left: 60px;
              position: relative;
              font-family: Microsoft YaHei;
              font-weight: bold;
              font-size: 20px;
              color: #ffffff;
              .li1_right_x {
                width: 1px;
                height: 24px;
                background-color: #fff;
                position: absolute;
                top: 74px;
                left: 152px;
              }
              .li1_right_jt {
                width: 24px;
                height: 13px;
                position: absolute;
                top: 0px;
                left: 164px;
                img {
                  width: 24px;
                  height: 13px;
                }
              }
              .li1_right_sz {
                width: 78px;
                height: 78px;
                font-size: 78px;
                color: #333333;
                font-weight: bold;
                font-family: Bahnschrift;
                opacity: 0.2;
                position: absolute;
                top: -30px;
                left: 130px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style>
.enterpriseCulture_Carousel {
  width: 716px !important;
  height: 510px !important;
  .el-carousel__container {
    height: 510px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/aboutUs/enterpriseCulture/EnterpriseCulture.vue